export enum ShapeTypeEnum {
  rectangle,
  l,
  reversedL,
  t,
  u,
  poolOutline,
}
